import { Button, Collapse, Form, Layout } from 'antd'
import { t } from 'i18next'
import { parsePhoneNumber } from 'react-phone-number-input'
import React, { useContext, useEffect, useState } from 'react'
import BoxForm from '../BoxesPage/BoxForm'
import BoxContext from './BoxContext'
import GlobalContext from '../GlobalContext'
import { WarningOutlined } from '@ant-design/icons'
import { displayBoxEmptyFields } from '../../Common/Common'
import CollapsePanel from 'antd/es/collapse/CollapsePanel'

export default function BoxInfoPage () {
  const [loading, setLoading] = useState(true)
  const { box, owners, updateBox } = useContext(BoxContext)
  const { user } = useContext(GlobalContext)
  const [form] = Form.useForm()

  const canEdit = user.roles.includes('admin') || user.roles.includes('setup') || user.roles.includes('supervisor')

  useEffect(() => {
    if (box) {
      const phone = box.interphone ? parsePhoneNumber(box.interphone, 'FR').number : undefined
      form.setFieldsValue({
        ...box,
        picture: box.picture_url?.url,
        waiting_time: box.waiting_time_url?.url,
        interphone: phone,
        interveners: box.interveners.map(i => ({ ...i, key: i.id }))
      })
      setLoading(false)
    }
  }, [box])

  const onFinish = (values) => {
    updateBox(values, form)
  }

  const collapseTitle = <>
      <WarningOutlined style={{ color: 'orange', fontSize: '20px', margin: '0 1.5em 0 0.5em' }} />
      {t('Admin.BoxInfoPage.collapseTitle')}
    </>

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white' }}>
      <h2>{t('Admin.BoxInfoPage.title')}</h2>
      {box?.empty_fields.length > 0 &&
        <Collapse style={{ marginBottom: '1em' }}>
          <CollapsePanel header={collapseTitle} key='1' showArrow={false}>
            {displayBoxEmptyFields(box.empty_fields)}
          </CollapsePanel>
        </Collapse>
      }
      {!loading && box && <div>
        <BoxForm form={form} onFinish={onFinish} owners={owners} state={canEdit ? 'edit' : 'show'}/>
        { canEdit &&
          <Button type="primary" htmlType="submit" onClick={form.submit}>
            {t('Admin.btn.submit')}
          </Button>
        }
      </div>
      }
    </Layout>
  )
}
